import {ComponentModalConfig, ModalSize, SuiModal} from '@angular-ex/semantic-ui';
import {Component, OnInit, AfterViewInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

import {InternalMessage} from '../../../core/models/internal-message/internal-message.model';
import {InternalMessageFormModalContext, InternalMessageFormValues} from './internal-message-form-modal.model';

@Component({
  selector: 'app-internal-message-form-modal',
  templateUrl: './internal-message-form-modal.component.html',
  styleUrls: ['./internal-message-form-modal.component.css'],
  standalone: false,
})
export class InternalMessageFormModalComponent implements OnInit, AfterViewInit {
  public internalMessageForm!: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    public modal: SuiModal<InternalMessageFormModalContext, InternalMessageFormValues, void>
  ) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    if (this.modal.context.editMessage) {
      this.updateValues(this.modal.context.editMessage);
    }
  }

  private initForm(): void {
    this.internalMessageForm = this.fb.group({
      saved: [false],
      title: ['', Validators.required],
      text: ['', Validators.required],
      extraInfo: [''],
    });
  }

  public submit(): InternalMessageFormValues {
    if (this.internalMessageForm.valid) {
      return this.internalMessageForm.value;
    } else {
      this.internalMessageForm.markAllAsTouched();
      return {saved: false, title: '', text: '', extraInfo: ''};
    }
  }

  // update form values with values from internal message
  public updateValues(internalMessage: InternalMessage): void {
    this.internalMessageForm.patchValue(internalMessage);
  }
}

export class InternalMessageFormModal extends ComponentModalConfig<InternalMessageFormModalContext, InternalMessageFormValues, void> {
  constructor(data: InternalMessageFormModalContext, size = ModalSize.Small) {
    super(InternalMessageFormModalComponent, data);

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
  }
}
